import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { isEmptyGuid } from '../../../../utils/emptyGuid'

const HeaderCheck = ({ headerData }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!!headerData.displayName && !isEmptyGuid(headerData.targetStorehouse.id)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [headerData])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('goodsReceiptOverlayProgress:headerData')}</span>
    </>
  )
}

export default HeaderCheck
